/* @flow */
import * as React from "react";
import styled from "styled-components";
import { gaReducer } from "../GA";

const Container = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  height: 53px;
  min-width: 42px;
  font-size: 0;
  line-height: 0;

  @media (max-width: 959px) {
    height: 38px;
  }
`;

const ToolsView = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-size: 0;
  line-height: 0;
`;

const Toggle = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 53px;
  width: 34px;
  text-align: center;

  @media (max-width: 959px) {
    height: 38px;
  }
`;

type ToolsProps = {
  children?: React.Node
};

export function Tools({ children }: ToolsProps) {
  return <ToolsView>{children}</ToolsView>;
}

type Props = {
  Icon: React.ComponentType<*>,
  children?: (_: { toggle: () => void }) => React.Node
};

type State = {
  isActive: boolean
};

class ToolSet extends React.Component<Props, State> {
  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.instruments && !state.isActive) {
      return {
        isActive: true
      };
    }

    return null;
  }

  state: State = {
    isActive: false
  };

  toggle = () => {
    this.setState({
      isActive: !this.state.isActive
    });
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  close = () => {
    this.setState({
      isActive: false
    });
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  render() {
    const { Icon, children, instruments } = this.props;
    const toggle = this.toggle;
    const close = this.close;
    const { isActive } = this.state;

    const tools =
      isActive && typeof children === "function"
        ? children({ toggle, instruments, close })
        : null;

    return (
      <Container active={isActive}>
        <Tools>
          <Toggle>
            <Icon
              onClick={() => {
                this.toggle();
                gaReducer("CLICKBTN_SHOW_TRADE_SETTINGS");
              }}
              isActive={isActive}
              className="js-click-outside-disable"
            />
          </Toggle>
        </Tools>
        {tools}
      </Container>
    );
  }
}

export default ToolSet;



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToolSet.js